import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  gap: var(--spacer-2);
`

Wrapper.displayName = 'Wrapper'

const defaultButtonStyles = css`
  cursor: pointer;
  font-size: 0.875rem;
  height: 1.5rem;
  padding: 0 var(--spacer-2);
  transition: filter 0.2s;

  &:hover:not([disabled]) {
    filter: brightness(1.2);
  }

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const CancelButton = styled.button`
  background-color: transparent;
  color: var(--gray-500);
  ${defaultButtonStyles};
`

CancelButton.displayName = 'CancelButton'

export const SubmitButton = styled.button`
  ${defaultButtonStyles};
`

SubmitButton.displayName = 'SubmitButton'
